import { CheckboxField, SelectField, TextField, useFormContext, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { IconButton } from '@calendly/ui/components/icon-button';
import { DeleteIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef, useEffect, useRef } from 'react';
import { useAdvancedSortable } from 'components/core/sortable';
import { allowsOtherChoices, hasAnswerChoices } from 'components/event_type_edit';
import { useErrorAfterInitialTouch } from '../../hooks';
import { StatusField } from '../status_field';
import { HeaderWithIcon, InlineEditingContainer, InputContainer, StyledDragIcon, SubsectionItemHeader } from '../styles';
import { AnswerChoiceSection } from './answer_choice_section';
import { getAnswerTypeOptions } from './helpers';
const styledCheckboxCss = "s5jxycj";
const StyledCheckbox = forwardRef((props, ref) => <CheckboxField ref={ref} {...props} className={classNames(styledCheckboxCss, props.className)} />);
export const InviteeQuestion = ({
  index,
  question
}) => {
  const ref = useRef();
  const [{
    value: format
  }] = useFormField({
    name: `inviteeQuestions.${index}.format`
  });
  const {
    values: {
      inviteeQuestions
    },
    setFieldValue,
    setFieldTouched
  } = useFormContext();
  const nameFieldName = `inviteeQuestions.${index}.name`;
  useErrorAfterInitialTouch(nameFieldName);
  const {
    sortable: {
      isDragging,
      attributes,
      listeners,
      setNodeRef
    },
    itemStyle
  } = useAdvancedSortable({
    id: question.id
  });
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    if (`${question.id}`.startsWith('new')) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      ref.current.focus();
    }
  }, [question.id]);
  const deleteQuestion = () => {
    let tempQuestions = [...inviteeQuestions];
    const removedQuestion = tempQuestions.splice(index, 1)[0];
    tempQuestions = tempQuestions.map((tempQuestion, newIndex) => ({
      ...tempQuestion,
      position: newIndex
    }));
    const isNewQuestion = String(removedQuestion.id).startsWith('new');
    if (isNewQuestion) {
      setFieldValue('inviteeQuestions', tempQuestions);
    } else {
      setFieldValue('inviteeQuestions', [...tempQuestions, {
        ...removedQuestion,
        format: 'destroy',
        enabled: false,
        _destroy: true
      }]);
    }
    setFieldTouched('inviteeQuestions', true);
  };
  if (question._destroy) return null;
  const answerTypeOptions = getAnswerTypeOptions();
  return <InlineEditingContainer ref={setNodeRef} isDragging={isDragging} {...itemStyle} id={`question-${question.position}`}>
      <SubsectionItemHeader>
        <HeaderWithIcon>
          <StyledDragIcon {...attributes} {...listeners} className="drag-handler" />
          <BodyText size="medium" weight="bold">
            {I18n.t('publisher.event_type_editor.sections.invitee_form.invitee_question.header', {
            position: question.position + 1
          })}
          </BodyText>
        </HeaderWithIcon>
        <IconButton aria-label={I18n.t('publisher.action.delete')} onClick={deleteQuestion} size="small" title={I18n.t('publisher.action.delete')}>
          <DeleteIcon />
        </IconButton>
      </SubsectionItemHeader>
      <TextField aria-label={nameFieldName} type="textarea" name={nameFieldName} maxLength={255} ref={ref} />
      <StyledCheckbox name={`inviteeQuestions.${index}.required`} label={I18n.t('publisher.event_types.invitee_questions.required_label')} />
      <InputContainer>
        <BodyText size="medium">{I18n.t('publisher.event_types.invitee_questions.answer_type_label')}</BodyText>
        <SelectField aria-label={I18n.t('publisher.event_types.invitee_questions.answer_type_label')} name={`inviteeQuestions.${index}.format`} options={answerTypeOptions} />
      </InputContainer>
      {hasAnswerChoices(format) && <InputContainer>
          <AnswerChoiceSection index={index} />
          {allowsOtherChoices(format) && <StyledCheckbox name={`inviteeQuestions.${index}.include_other`} label={I18n.t('publisher.event_types.invitee_questions.include_other_option')} />}
        </InputContainer>}
      <StatusField name={`inviteeQuestions.${index}.enabled`} />
    </InlineEditingContainer>;
};

require("./invitee_question.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./invitee_question.js");